import { render, staticRenderFns } from "./AtualizarTroncos.vue?vue&type=template&id=aa4816c4&"
import script from "./AtualizarTroncos.vue?vue&type=script&lang=js&"
export * from "./AtualizarTroncos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports